export default {
	//getItem: state => (companyId) => state.companies.find((company) => company.id == companyId),
	//getAllItem: state => () => state.companies,
	totalStatus: (state) => () => state.status.length,
	getResources: (state) => () => state.resources,
	getResourcesForSelect: (state) => () => state.getResourcesForSelect,
};
